import { Ellipsis } from "lucide-react";
import styles from "./Pagination.module.css";

const WINDOW = 3;

// Shows a sliding window of three page numbers; the ellipsis jumps to the next window
export default function Pagination({ page, pageCount, onChange }) {
  if (pageCount <= 1) {
    return null;
  }

  const start = Math.max(1, Math.min(page - 1, pageCount - WINDOW + 1));
  const pages = Array.from({ length: Math.min(WINDOW, pageCount) }, (_, index) => start + index);
  const hasMore = pages[pages.length - 1] < pageCount;

  return (
    <nav className={`${styles.pagination} d-flex justify-content-center`} aria-label="Pagination">
      {pages.map((number) => (
        <button
          key={number}
          type="button"
          className={`${styles.page} ${number === page ? styles.pageActive : ""}`}
          onClick={() => onChange(number)}
          aria-current={number === page ? "page" : undefined}
        >
          {number}
        </button>
      ))}
      {hasMore ? (
        <button
          type="button"
          className={`${styles.page} ${styles.more}`}
          onClick={() => onChange(Math.min(pageCount, pages[pages.length - 1] + 1))}
          aria-label="More pages"
        >
          <Ellipsis size={24} strokeWidth={1.75} aria-hidden="true" />
        </button>
      ) : null}
    </nav>
  );
}
